import {useQuery} from "@apollo/client";
import {
	TaskAltOutlined,
	ErrorOutline,
	Attachment,
	Download,
} from "@mui/icons-material";
import {
	List,
	ListItem,
	ListItemAvatar,
	Avatar,
	ListItemText,
	Button,
	IconButton,
} from "@mui/material";
import React, {useEffect} from "react";
import {graphQLServices} from "../../../../services/GraphQLServices";
import {GET_ATTACHMENT} from "../../graphql/queries/gqlGetAttachment";
import {GET_MAIL} from "../../graphql/queries/gqlGetMail";
import {download} from "../../helpers/FileHelper";
import {isSuccessStatus, mapStatus} from "../../helpers/MailexStatusHelper";
import {MailAttachment} from "../../models/MailAttachment";
import {MailLog} from "../../models/MailLog";

interface IMailDescriptionProps {
	mailId: string;
}

export const MailDescription: React.FC<IMailDescriptionProps> = ({ mailId }) => {
	const { data, loading, error, refetch } = useQuery(GET_MAIL, {
		client: graphQLServices.mailexClient,
		fetchPolicy: "no-cache",
		variables: {
			mailId: mailId,
		},
	});

	useEffect(() => {
		refetch();
	}, [refetch]);

	if (loading) return <div>loading</div>;
	if (error) return <div>error</div>;

	const downloadAttachment = (key: string) => {
		graphQLServices.mailexClient
			.query({
				query: GET_ATTACHMENT,
				variables: {
					key: key,
				},
			})
			.then((result: any) => {
				download(
					result.data.attachment,
					key.substring(key.lastIndexOf("/") + 1)
				);
			});
	};

	return (
		<div>
			<h3>Email:</h3>
			<Button
				onClick={() => {
					const wnd = window.open("about:blank", "", "_blank");
					wnd?.document.write(data.mails.nodes[0].body);
				}}
				variant="outlined"
			>
				View email
			</Button>
			<h3>Attachments:</h3>
			<List sx={{ maxWidth: "400px" }}>
				{[...data.mails.nodes[0].attachments].map(
					(attachment: MailAttachment, index: number) => {
						return (
							<ListItem
								key={`mailex-mail-attachment-${index}`}
								secondaryAction={
									<IconButton
										onClick={() => downloadAttachment(attachment.key)}
									>
										<Download />
									</IconButton>
								}
							>
								<ListItemAvatar>
									<Avatar>
										<Attachment />
									</Avatar>
								</ListItemAvatar>
								<ListItemText
									primary={attachment.key.substring(
										attachment.key.lastIndexOf("/") + 1
									)}
								/>
							</ListItem>
						);
					}
				)}
			</List>
			<h2>Events:</h2>
			<List>
				{[...data.mails.nodes[0].logs]
					.sort(
						(a: MailLog, b: MailLog) =>
							new Date(b.dateTimeStamp).getTime() -
							new Date(a.dateTimeStamp).getTime()
					)
					.map((log: MailLog, index: number) => {
						return (
							<ListItem key={`mailex-mail-log-${index}`}>
								<ListItemAvatar>
									<Avatar>
										{isSuccessStatus(log.status) ? (
											<TaskAltOutlined color="success" />
										) : (
											<ErrorOutline color="error" />
										)}
									</Avatar>
								</ListItemAvatar>
								<ListItemText
									primary={mapStatus(log.status)}
									secondary={log.dateTimeStamp}
								/>
							</ListItem>
						);
					})}
			</List>
		</div>
	);
};
